import { useEffect } from "react";

export const iFrameCssClasses = {
    byXpath: "highlighted-by-xpath",
    visible: "highlighted-by-xpath-visible",
    active: "highlighted-by-xpath-active",
    hovered: "highlighted-by-xpath-hovered"
};

const useIframeCommand = ({ iframeRef, html, onClickIframe }) => {
    /*eslint-disable */
    useEffect(
        () => {
            let iframe = iframeRef.current;

            iframe = iframe.contentWindow || (iframe.contentDocument.document || iframe.contentDocument);
            iframe.document.open();
            iframe.document.write(html);
            iframe.document.close();

            iframe.document.addEventListener("click", onClickIframe, true);

            const styleTag = document.createElement("style");
            styleTag.textContent = `
            body { overflow-y: hidden !important };
            
            .${iFrameCssClasses.byXpath} { background: #ce3636 !important; color: #ffffff !important; border: 2px solid #ce3636 !important;}
            
            .${iFrameCssClasses.visible} { display: block; background: #fabc6e !important; color: #ffffff !important; border: 2px solid #fabc6e !important; }
            
            .${iFrameCssClasses.active} { display: block; background: #f56b6b !important; color: black !important; border: 2px solid #f56b6b !important; }
            
            .${iFrameCssClasses.hovered} { display: block; background: #3b8cee !important; color: #ffffff !important; color: black !important; border: 2px solid #3b8cee !important;}
            `;
            iframe.document.head.appendChild(styleTag);

            return () => {
                iframe.document.removeEventListener("click", onClickIframe)
            }
        },
        [ html, onClickIframe ]
    );
};


export default useIframeCommand;
